

import React from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';

const HomeCampaigns = (props) => {
  const { data, history } = props;
  const { data: homeCampaigns } = data || {};
  return (
    <div>
        <Carousel autoPlay={true} showThumbs={false} interval={5000} infiniteLoop={true} showStatus={false} className="homepage-banner">
          {
            homeCampaigns && homeCampaigns.length && homeCampaigns.map(({ id, story, cover_photo: coverPhoto, title }, index) => {
              return <div key={index}>
                <section className="bannerForHomeCampaigns">
                  <div className="container">
                    <div className="row  ">
                      <div className="col-lg-6 col-md-12 col-sm-12 banner-text-col">
                        <h1>
                          Raise funds for those
                          <span className="d-block"> you care about</span>
                        </h1>
                        <p className="">
                          Our vision is for a world where no one is <br></br>
                          needlessly blind, and Indigenous Australians<br></br>
                          enjoy the same health and life expectance as other Australians.
                        </p>
                        <button 
                          style={{ float:'left' }} 
                          onClick={() => {
                            history.push({
                              pathname: `/donate-money/${id}`
                            });
                          }} 
                          type="button" 
                          className="btn btn-outline-light ">
                            Donate now
                        </button>
                        <button style={{ float:'left' }} onClick={() => history.push('/starting_fund')} type="button" className="btn btn-success  ml-2 btn_hover">Start fundraising</button>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            })
          }
        </Carousel>
    </div>
  );
}

export default HomeCampaigns;
